// This file is auto-generated by build-artifacts.ts
import { type MockArtifact } from './types';

export const MockACLArtifact = {
  contractName: 'MockACL',
  isFixed: false,
  abi: [
    {
      type: 'constructor',
      inputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'TASK_MANAGER_ADDRESS_',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'address',
          internalType: 'address',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'allow',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'requester',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowForDecryption',
      inputs: [
        {
          name: 'handlesList',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
        {
          name: 'requester',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowGlobal',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'requester',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowTransient',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'requester',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'allowedOnBehalf',
      inputs: [
        {
          name: 'delegatee',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'contractAddress',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'allowedTransient',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'checkPermitValidity',
      inputs: [
        {
          name: 'permission',
          type: 'tuple',
          internalType: 'struct Permission',
          components: [
            {
              name: 'issuer',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'expiration',
              type: 'uint64',
              internalType: 'uint64',
            },
            {
              name: 'recipient',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'validatorId',
              type: 'uint256',
              internalType: 'uint256',
            },
            {
              name: 'validatorContract',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'sealingKey',
              type: 'bytes32',
              internalType: 'bytes32',
            },
            {
              name: 'issuerSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
            {
              name: 'recipientSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
          ],
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'cleanTransientStorage',
      inputs: [],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'delegateAccount',
      inputs: [
        {
          name: 'delegatee',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'delegateeContract',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [],
      stateMutability: 'nonpayable',
    },
    {
      type: 'function',
      name: 'eip712Domain',
      inputs: [],
      outputs: [
        {
          name: 'fields',
          type: 'bytes1',
          internalType: 'bytes1',
        },
        {
          name: 'name',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'version',
          type: 'string',
          internalType: 'string',
        },
        {
          name: 'chainId',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'verifyingContract',
          type: 'address',
          internalType: 'address',
        },
        {
          name: 'salt',
          type: 'bytes32',
          internalType: 'bytes32',
        },
        {
          name: 'extensions',
          type: 'uint256[]',
          internalType: 'uint256[]',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'exists',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'pure',
    },
    {
      type: 'function',
      name: 'getTaskManagerAddress',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'address',
          internalType: 'address',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'getVersion',
      inputs: [],
      outputs: [
        {
          name: '',
          type: 'string',
          internalType: 'string',
        },
      ],
      stateMutability: 'pure',
    },
    {
      type: 'function',
      name: 'globalAllowed',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'hashTypedDataV4',
      inputs: [
        {
          name: 'structHash',
          type: 'bytes32',
          internalType: 'bytes32',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bytes32',
          internalType: 'bytes32',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isAllowed',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isAllowedForDecryption',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'isAllowedWithPermission',
      inputs: [
        {
          name: 'permission',
          type: 'tuple',
          internalType: 'struct Permission',
          components: [
            {
              name: 'issuer',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'expiration',
              type: 'uint64',
              internalType: 'uint64',
            },
            {
              name: 'recipient',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'validatorId',
              type: 'uint256',
              internalType: 'uint256',
            },
            {
              name: 'validatorContract',
              type: 'address',
              internalType: 'address',
            },
            {
              name: 'sealingKey',
              type: 'bytes32',
              internalType: 'bytes32',
            },
            {
              name: 'issuerSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
            {
              name: 'recipientSignature',
              type: 'bytes',
              internalType: 'bytes',
            },
          ],
        },
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'function',
      name: 'persistAllowed',
      inputs: [
        {
          name: 'handle',
          type: 'uint256',
          internalType: 'uint256',
        },
        {
          name: 'account',
          type: 'address',
          internalType: 'address',
        },
      ],
      outputs: [
        {
          name: '',
          type: 'bool',
          internalType: 'bool',
        },
      ],
      stateMutability: 'view',
    },
    {
      type: 'event',
      name: 'AllowedForDecryption',
      inputs: [
        {
          name: 'handlesList',
          type: 'uint256[]',
          indexed: false,
          internalType: 'uint256[]',
        },
      ],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'EIP712DomainChanged',
      inputs: [],
      anonymous: false,
    },
    {
      type: 'event',
      name: 'NewDelegation',
      inputs: [
        {
          name: 'sender',
          type: 'address',
          indexed: true,
          internalType: 'address',
        },
        {
          name: 'delegatee',
          type: 'address',
          indexed: true,
          internalType: 'address',
        },
        {
          name: 'contractAddress',
          type: 'address',
          indexed: true,
          internalType: 'address',
        },
      ],
      anonymous: false,
    },
    {
      type: 'error',
      name: 'AlreadyDelegated',
      inputs: [],
    },
    {
      type: 'error',
      name: 'DirectAllowForbidden',
      inputs: [
        {
          name: 'sender',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'InvalidShortString',
      inputs: [],
    },
    {
      type: 'error',
      name: 'PermissionInvalid_Disabled',
      inputs: [],
    },
    {
      type: 'error',
      name: 'PermissionInvalid_Expired',
      inputs: [],
    },
    {
      type: 'error',
      name: 'PermissionInvalid_IssuerSignature',
      inputs: [],
    },
    {
      type: 'error',
      name: 'PermissionInvalid_RecipientSignature',
      inputs: [],
    },
    {
      type: 'error',
      name: 'SenderCannotBeDelegateeAddress',
      inputs: [],
    },
    {
      type: 'error',
      name: 'SenderNotAllowed',
      inputs: [
        {
          name: 'sender',
          type: 'address',
          internalType: 'address',
        },
      ],
    },
    {
      type: 'error',
      name: 'StringTooLong',
      inputs: [
        {
          name: 'str',
          type: 'string',
          internalType: 'string',
        },
      ],
    },
  ],
} as const satisfies MockArtifact;
